module.exports = __webpack_public_path__ + "img/climate-change.174f3959.svg";